// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slurpuff: PokeData = {
  "id": 685,
  "name": "slurpuff",
  "height": 8,
  "weight": 50,
  "base_experience": 168,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "string-shot",
    "light-screen",
    "cotton-spore",
    "safeguard",
    "sweet-scent",
    "wish",
    "endeavor",
    "aromatherapy",
    "fake-tears",
    "energy-ball",
    "round",
    "cotton-guard",
    "sticky-web",
    "draining-kiss",
    "play-rough",
    "fairy-wind",
    "play-nice"
  ],
  "moves": [
    "tackle",
    "string-shot",
    "aromatherapy",
    "energy-ball",
    "sticky-web",
    "play-rough",
    "spirit-break",
    "moonblast",
    "heal-bell",
    "starfall",
    "hyper-voice",
    "dazzling-gleam",
    "guardian-bond"
  ],
  "evolution_chain": {
    "id": 351,
    "item": null,
    "species": [
      {
        "name": "swirlix",
        "order": 685,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "slurpuff",
        "order": 686,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 684,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 121,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 140,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
